class ApiError extends Error {
  constructor(props) {
    super(props);
    this.name = 'Api Error';
    this.response = props.response;
  }
}

const getErrorMessages = (response) => {
  if (response.status >= 500) {
    return { messages: [{ message: 'MSG_TEXT_SOMETHING_WENT_WRONG' }] };
  }

  if (typeof response.data === 'string') {
    return { messages: [{ message: response.data }] };
  }

  return {};
};

const throwGenericError = (response = {}) => {
  throw new ApiError({
    response: {
      ...response,
      status: 0,
      httpReqStatus: response.status,
      ...getErrorMessages(response),
    },
  }).response;
};

const concatErrorMsgs = (messages) => messages.map(({ message }) => message).join('');

// Reads { code, message } from an error response in either shape: 200 + status 0 (messages at
// the top) or a real HTTP error reshaped by throwGenericError (messages under data).
const readApiError = (response = {}) => {
  const body = Array.isArray(response.messages) ? response : (response.data || {});
  const [firstMessage] = body.messages || [];

  return {
    code: firstMessage?.code || '',
    message: firstMessage?.message || '',
    httpStatus: response.httpReqStatus,
  };
};

export {
  ApiError as default, concatErrorMsgs, throwGenericError, readApiError,
};
